import React from 'preact/compat'
import cn from 'classnames'
import Api from '../../api'
import { captureException, loadStylesheet } from '../../common/helpers'
import styles from '../../../css/2fa.pcss.json'
import formCss from '../../../css/form.pcss.json'
import buttonsCss from '../../../css/buttons.pcss.json'
import { showToast } from '../toast'

interface PropTypes {
  close: () => void
}

interface StateTypes {
  sending: boolean,
  error: boolean,
}

export default class TwoFAEnableForm extends React.Component<PropTypes, StateTypes> {
  state: StateTypes = {
    sending: false,
    error: false
  }

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('2fa')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  onSubmit = (event: React.TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    this.setState({
      sending: true
    })
    Api.post({ url: 'user/2fa-disable', body: formData })
      .then(response => {
        if (response.success) {
          showToast({
            type: 'success',
            text: 'Аутентификатор успешно удалён'
          })
          this.props.close()
          const buttons = document.querySelectorAll('[data-manage-2fa]')
          buttons.forEach(button => {
            button.innerHTML = 'Привязать аутентификатор'
            button.setAttribute('data-manage-2fa', 'enable')
          })
          return
        }
        this.setState({
          error: true,
          sending: false
        })
      })
      .catch(e => {
        captureException('TwoFA Disable Form', e)
        showToast({
          type: 'error',
          text: 'При удалении аутентификатора произошла ошибка'
        })
        this.setState({
          sending: false
        })
      })
  }

  onInput = () => {
    const { error } = this.state
    if (error) {
      this.setState({
        error: false
      })
    }
  }

  render() {
    const { sending, error } = this.state

    return <form onSubmit={this.onSubmit} className={styles['form']}>
      <h2>Введи код из приложения</h2>
      <input
        type='text'
        name='otp'
        onInput={this.onInput}
        pattern='\d{6}'
        required
        className={cn(formCss['input'], styles['input'], {
          [formCss['input--error']]: error
        })}
        placeholder='Код из приложения'
        title='Шесть цифр без пробелов'
      />
      {error && <span className={styles['error']}>Неверный код</span>}
      <button type='submit' className={cn(buttonsCss['primary'], styles['button'])} disabled={sending}>
        Удалить аутентификатор
      </button>
    </form>
  }
}
